export default __webpack_public_path__ + "static/media/edit2.8c2355fd.svg";